// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkWithIcon-module__link___12Qp-","link__text":"LinkWithIcon-module__link__text___23gDS"};